import {
  editServiceCredit,
  removeServiceCredit,
  updateServiceCredits,
  editServiceCreditAtomic,
} from './actions';

export default {
  [editServiceCredit]: (state, { payload: { data } }) => {
    const { id, ...rest } = data;

    return {
      ...state,
      serviceCredits: {
        ...state.serviceCredits,
        [id]: {
          ...state.serviceCredits[id],
          ...rest,
        },
      },
    };
  },
  [removeServiceCredit]: (state, { payload: { data: { id, deletedAt, deletedBy } } }) => ({
    ...state,
    serviceCredits: {
      ...state.serviceCredits,
      [id]: {
        ...state.serviceCredits[id],
        deletedAt,
        deletedBy,
        archived: true,
      },
    },
  }),
  [updateServiceCredits]: (state, { payload: { data } }) => ({
    ...state,
    serviceCredits: {
      ...state.serviceCredits,
      ...data,
    },
  }),
  [editServiceCreditAtomic]: (state, { payload: { id, field, value, updatedAt, updatedBy } }) => ({
    ...state,
    serviceCredits: {
      ...state.serviceCredits,
      [id]: {
        ...state.serviceCredits[id],
        [field]: value,
        updatedAt,
        updatedBy,
      },
    },
  }),
};
